// Module
var code = "<div id=\"error-page\" flex> <div id=\"middle-section\" flex> <div layout=\"column\" layout-align=\"center start\"> <div class=\"content\"> {{'marketplace.connection-lost'|translate}}<br/>{{'marketplace.please-wait-error'|translate}} </div> </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/error.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;